import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jswStandardCarouslSlideUserLimit: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-limit',
		defaultMessage: 'Unlimited users',
		description: 'Modal dialog description that the Jira Standard plan has unlimted user',
	},
	jswStandardCarouslSlideAuditLog: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-audit-log',
		defaultMessage: 'Audit Log',
		description: 'Modal dialog carousel slide text for audit log',
	},
	jswStandardCarouslSlideUserAutomation: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-automation',
		defaultMessage: 'Automation',
		description: 'Modal dialog carousel slide text for automation',
	},
	jswStandardCarouslSlideUserPermissions: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-permissions',
		defaultMessage: 'User permissions',
		description: 'Modal dialog carousel slide text for user permission',
	},
	jswStandardCarouslSlideStorageLimit: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-storage-limit',
		defaultMessage: 'Storage limit',
		description: 'Modal dialog carousel slide text for storage limit',
	},
	jswStandardTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-title',
		defaultMessage:
			'Your Standard trial ends in {trialDaysLeft, plural, one {# day} other {# days}}',
		description: 'Modal dialog Title about standard trial with x days left',
	},
	jswStandardSubTitle: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title',
		defaultMessage:
			'There’s still time to try advanced features. Don’t lose access — add payment before your trial ends.',
		description: 'Modal dialog Sub Title',
	},
	jswStandardSubTitleUrgent: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-urgent',
		defaultMessage: 'Don’t lose access to advanced features. Add payment before your trial ends.',
		description: 'Modal dialog Sub Title Urgent',
	},
	jswStandardSubTitleNoPay: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-no-pay',
		defaultMessage:
			'There’s still time to try advanced features. Don’t lose access — ask your admin to purchase Jira Standard.',
		description: 'Modal dialog Sub Title cannot pay',
	},
	jswStandardSubTitleUrgentNoPay: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-urgent-no-pay',
		defaultMessage:
			'Don’t lose access to advanced features. Ask your admin to purchase Jira Standard for your team.',
		description: 'Modal dialog Sub Title Urgent cannot pay',
	},
	jswStandardPrimaryCtaText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-primary-cta-text',
		defaultMessage: 'Add payment',
		description: 'Modal dialog primary cta text for can pay',
	},
	jswStandardPrimaryCtaTextNoPay: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-primary-cta-text-no-pay',
		defaultMessage: 'Close',
		description: 'Modal dialog primary cta text for no pay',
	},
	jswStandardSecondaryCtaText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.jsw-standard-secondary-cta-text',
		defaultMessage: 'Maybe later',
		description: 'Modal dialog secondary cta text for can pay',
	},

	addPeopleSvgText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.add-people-svg-text',
		defaultMessage: 'Add people',
		description: 'Add people text in jira loss aveersion model',
	},
	attachmentsSvgText1: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.attachments-svg-text-1',
		defaultMessage: 'Attachments',
		description: 'Attachments text in jira loss aveersion model',
	},
	auditLogSvgText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.audit-log-svg-text',
		defaultMessage: 'Audit log',
		description: 'Audit log text in jira loss aveersion model',
	},
	automationSvgText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.automation-svg-text',
		defaultMessage: 'Automation rule',
		description: 'Automation text in jira loss aveersion model',
	},
	userPermissionsSvgText: {
		id: 'loss-aversion.loss-aversion-modal.split-panel.user-permissions-svg-text',
		defaultMessage: 'Project Access',
		description: 'User permissions text in jira loss aveersion model',
	},
});
